type Platform = "instagram" | "x" | "tiktok" | "threads";

type SocialAccount = {
  default: string;
  ja?: string;
};

const SOCIAL_ACCOUNTS: Record<Platform, SocialAccount> = {
  instagram: {
    // TODO: 글로벌 계정 활성화 시 default를 https://www.instagram.com/locarora.global 로 변경하고
    // ja: "https://www.instagram.com/locarora_jp" 추가 (또는 두 계정 모두 푸터에 노출)
    default: "https://www.instagram.com/locarora_jp",
  },
  x: {
    default: "https://x.com/locarora",
  },
  tiktok: {
    default: "https://www.tiktok.com/@locarora",
  },
  threads: {
    default: "https://www.threads.net/@locarora_jp",
  },
};

export function getSocialUrl(platform: Platform, locale: string): string {
  const account = SOCIAL_ACCOUNTS[platform];
  if (locale === "ja" && account.ja) return account.ja;
  return account.default;
}

/**
 * 푸터 아이콘으로는 노출하지 않지만 검색엔진에 "공식 채널"로 알려야 하는 URL.
 * 구글은 Organization sameAs 로 검색 결과의 프로필 버튼을, 네이버는 같은 목록을
 * "연관 채널"로 읽는다. 채널이 생기면 여기에 한 줄 추가.
 */
const OFFICIAL_CHANNEL_URLS = [
  "https://blog.naver.com/locarora",
  "https://apps.apple.com/us/app/locarora/id6768569347",
  "https://play.google.com/store/apps/details?id=com.locarora.app",
];

/** 브랜드 공식 프로필 전체 (dedup) — Organization JSON-LD sameAs 용 */
export function getAllSocialUrls(): string[] {
  return [
    ...new Set([
      ...Object.values(SOCIAL_ACCOUNTS).flatMap((a) =>
        [a.default, a.ja].filter((u): u is string => !!u),
      ),
      ...OFFICIAL_CHANNEL_URLS,
    ]),
  ];
}
